export enum PageType {
  Math = 'MATH',
  Ela = 'ELA',
  Demo = 'DEMO',
  Aggregator = 'AGGREGATOR',
}

export enum AppRoute {
  Home = '/',
  TutorHome = '/tutor/',
  Math = '/tutor/math',
  Ela = '/tutor/ela',
  Demo = '/tutor/demo',
}
